import React, { Component } from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import ConfirmationModal from '../forms/ConfirmationModal';
import { getText } from '../../../constants/admin/texts';
import DropdownMenu from '../../forms/DropdownMenu';
import { compact } from 'lodash';

class SelectionActions extends Component {
    constructor(props) {
        super(props);
        this.state = { deleting: false };
    }
    _closeModal = () => this.setState({ deleting: false });
    _openModal = () => this.setState({ deleting: true });
    _delete = () => {
        this.props.deleteAction();
        this._closeModal();
    };
    _selectionActions = () =>
        compact([...(this.props.selectionActions || []), this.props.deleteAction ? 'DELETE' : null]);

    render() {
        const _selectionFunctions = compact([
            ...(this.props.selectionFunctions || []),
            this.props.deleteAction ? this._openModal : null
        ]);
        return this.props.selection.length ? (
            <div className="ckp-admin-action-bar-button-frame is-select-actions">
                <ConfirmationModal
                    open={this.state.deleting}
                    onClose={this._closeModal}
                    onConfirm={this.props.isBusy ? null : this._delete}
                    confirmText={getText(
                        this.props.model,
                        this.props.selection.length > 1 ? 'tableConfirmDeleteMultiple' : 'tableConfirmDelete'
                    )}
                    confirmLabel="Delete"
                />
                {this.props.deleteAction && !this.props.selectionActions ? (
                    <a
                        onClick={
                            this.props.isBusy ? null : this.props.skipDeleteConfirm ? this._delete : this._openModal
                        }
                        className={`ckp-admin-action-bar-delete ckp-admin-action-bar-click ${
                            this.props.isBusy ? 'is-disabled' : ''
                        }`}
                    >
                        <DeleteIcon className="ckp-admin-action-bar-click-icon" color="inherit" />
                        Delete
                    </a>
                ) : null}
                {this.props.selectionActions ? (
                    <DropdownMenu
                        label="More"
                        disabled={false}
                        options={this._selectionActions()}
                        selectFunctions={_selectionFunctions}
                    />
                ) : null}
            </div>
        ) : null;
    }
}

export default SelectionActions;



// WEBPACK FOOTER //
// ./src/components/admin/tables/SelectionActions.js